import { render } from "./PurchaseOrderForm.vue?vue&type=template&id=0849cb8a"
import script from "./PurchaseOrderForm.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderForm.vue?vue&type=script&lang=js"

import "./PurchaseOrderForm.vue?vue&type=style&index=0&id=0849cb8a&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__